module.exports = __webpack_public_path__ + "static/media/gal5.36eae116.jpg";